export default "__VITE_ASSET__DxuhEBwt__"